<template>
	<v-container class="contact none-fluid link">
		<banner>Contact</banner>
		<br />
		<div class="mx-auto contact-content">
			<img :src="intro.url" alt="image" class="contact-image" />
			<br />
			<br />
			<p v-html="$sanitize(intro.content)"></p>
			<br />
			<br />
			<h3>{{ researchers_title }}</h3>
			<br />
			<p v-html="$sanitize(researchers_intro)"></p>
			<br />
			<v-expansion-panels multiple>
				<v-expansion-panel v-for="researcher in researchers" :key="researcher.subtitle">
					<v-expansion-panel-header class="expansion-header">{{ researcher.subtitle }}</v-expansion-panel-header>
					<v-expansion-panel-content class="expansion-content">
						<div class="expansion-subsection" v-html="$sanitize(researcher.content)"></div>
					</v-expansion-panel-content>
				</v-expansion-panel>
			</v-expansion-panels>
			<br />
			<br />
			<h3>Prospective Study Participants
			</h3>
			<br />
			<p v-html="$sanitize(participantsContent.content)"></p>
			<br />
			<h3>Location</h3>
			<br />
			<v-row justify="center">
				<v-col cols="12" lg="8">
					<iframe
						src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3306.844987777397!2d-118.28758384555003!3d34.022189701969104!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x80c2c7fc9b34f34b%3A0x60b323c932173402!2sRonald%20Tutor%20Hall%20(RTH)!5e0!3m2!1sen!2sus!4v1573966405400!5m2!1sen!2sus"
						width="500"
						height="400"
						frameborder="0"
						style="border:0;"
						class="google-map"
						allowfullscreen
					></iframe>
				</v-col>
				<v-col cols="12" lg="4">
					<v-row align="start">
						<v-col cols="2">
							<i class="mdi mdi-map-marker-radius" onclick />
						</v-col>
						<v-col cols="8" v-html="$sanitize(contact.location)"></v-col>
					</v-row>
					<v-row align="center">
						<v-col cols="2">
							<i class="mdi mdi-phone" />
						</v-col>
						<v-col cols="6">{{contact.number}}</v-col>
					</v-row>
				</v-col>
			</v-row>
		</div>
	</v-container>
</template>

<script>
import Banner from "../global/Banner";
import {
	getIntroduction,
	getContactInfo,
	getResearchers,
	getParticipants,
} from "../../service/contact";

export default {
	components: {
		Banner
	},
	data() {
		return {
			intro: {},
			contact: {},
			researchers_title: "",
			researchers_intro:"",
			researchers: [],
			participantsContent : {}
		};
	},
	mounted() {
		// get introduction
		getIntroduction()
			.then(intro => {
				this.intro = intro;
			})
			.catch(err => {
				console.error(err.message);
			});
		// get contact info
		getContactInfo()
			.then(contact => {
				this.contact = contact;
			})
			.catch(err => {
				console.error(err.message);
			});
		// get researchers
		getResearchers()
			.then(result => {
				const { introduction, title, researchers } = result;
				this.researchers_intro = introduction;
				this.researchers_title = title;
				this.researchers = researchers;
			})
			.catch(err => {
				console.error(err.message);
			});
		// get participants content
		getParticipants()
			.then(content => {
				this.participantsContent = content;
			})
			.catch(err => {
				console.error(err.message);
			});
	}
};
</script>

<style lang="scss">
.contact {
	i {
		font-size: 25px;
	}

	.contact-content {
		.contact-image {
			max-width: 950px;
			width: 100%;
			display: block;
			margin-left: auto;
			margin-right: auto;
		}

		.google-map {
			position: relative;
		}
	}
}

/**
 * following are responsive support
 */
@media (max-width: 420px) {
	.contact {
		.contact-content {
			.google-map {
				position: relative;
				width: 100% !important;
				height: 300px !important;
			}
		}
	}
}
</style>